import { ListItem } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';

// Redux
import { setModalIsOpened } from '@/main/store/modal';
import {
  setMenuItemSelected,
  setOpenMenu,
  useMenuReducer
} from '../../../store/menu';

// Models
import { MenuItemResponse, MenuResponse } from '../../../models/response/menu';

// Components
import TooltipComponent from '../../shared/tooltip/tooltipComponent';
import DrawerMenuIconComponent from './drawerMenuIconComponent';

// Styles
import { useVisualIdentityReducer } from '@/main/store/visualIdentity';
import * as S from './styles';

const useStylesTooltip = makeStyles({
  popperCustom: { marginLeft: 15 }
});

function RenderTooltip(props: { open: boolean; child: any; title: string }) {
  const classesTooltip = useStylesTooltip();
  if (!props.open)
    return (
      <TooltipComponent
        title={props.title || ''}
        placement="right"
        stylePopper={classesTooltip.popperCustom}>
        <div>{props.child}</div>
      </TooltipComponent>
    );
  return props.child;
}

export default function DrawerMenuItemComponent(props: {
  menu: MenuResponse;
  open: boolean;
  key: number;
  preOpenMenu: boolean;
  setParentMenuSelected: (parentMenu: string) => void;
  parentMenuSelected: string;
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Styles
  const classes = S.useStyles();

  // Reducers
  const menuReducer = useMenuReducer();
  const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
  // States
  const [openSectionMenu, setOpenSectionMenu] = useState(false);
  const [clickMenu, setClickMenu] = useState(false);

  useEffect(() => {
    if (!props.open) {
      setOpenSectionMenu(false);
      setClickMenu(false);
    } else {
      if (props.parentMenuSelected === '') {
        setOpenSectionMenu(isMenuSelected());
        setClickMenu(isMenuSelected());
      }
    }
  }, [props.open]);

  function hasSubMenu() {
    return props.menu.screens !== undefined && props.menu.screens.length > 0;
  }

  function getClassNameMenuSelected() {
    const hasRoute = hasSubMenu()
      ? props.menu.screens.find(
        screen => screen.route === menuReducer.menuItemSelected
      )
      : props.menu;
    return hasRoute?.route === menuReducer.menuItemSelected
      ? 'menu-item-selected'
      : '';
  }

  function isMenuSelected() {
    const hasRoute = hasSubMenu()
      ? props.menu.screens.find(
        screen => screen.route === menuReducer.menuItemSelected
      )
      : props.menu;
    const selectThisItem = hasRoute?.route === menuReducer.menuItemSelected;

    return selectThisItem;
  }

  let hasKeyPress = false;

  document.addEventListener('keyup', keyUpHandler);
  document.addEventListener('keydown', keyDownHandler);

  function keyDownHandler() {
    hasKeyPress = true;
  }

  function keyUpHandler() {
    hasKeyPress = false;
  }

  function renderMenuItems() {
    const { screens } = props.menu;
    const screensFormated = screens.filter(screen => screen.viewMenu === true);
    return screensFormated
      .sort((menuA, menuB) => menuA.name.localeCompare(menuB.name))
      .map((item: MenuItemResponse) => (
        <div
          key={item.name}
          className={
            item.route === menuReducer.menuItemSelected
              ? 'menu-item-selected'
              : ''
          }
          style={{
            padding: '0px 0px 0px 15px',
            minWidth: 134
          }}>
          <div
            style={
              item.route === menuReducer.menuItemSelected
                ? {
                  borderRadius: 2,
                  padding: '8px 0'
                }
                : { padding: '8px 0' }
            }>
            <Link
              onClick={() => {
                if (!hasKeyPress) {
                  dispatch(setMenuItemSelected(item.route));
                  dispatch(setOpenMenu(false));
                }
              }}
              style={{
                display: 'block',
                fontSize: 12,
                color:
                  item.route === menuReducer.menuItemSelected
                    ? '#333'
                    : '#6C7882',
                fontWeight:
                  item.route === menuReducer.menuItemSelected ? 'bold' : 'normal',
                whiteSpace: 'normal',
                margin: '0px 17px 0px 5px'
              }}
              to={item.route}>
              {item.name}
            </Link>
          </div>
        </div>
      ));
  }

  function openMenuList() {
    if (!hasKeyPress) {
      if (!hasSubMenu()) {
        dispatch(setMenuItemSelected(props.menu.route));
      }
      setClickMenu(!clickMenu);
      setOpenSectionMenu(false);
    }
  }

  function renderIconMenuOpen() {
    if (props.menu.screens && props.menu.screens.length > 0) {
      return !clickMenu ? (
        <ExpandMoreIcon
          className={classes.iconMenu}
          onClick={() => openMenuList()}
        />
      ) : (
        <ExpandLessIcon
          className={classes.iconMenu}
          onClick={() => openMenuList()}
        />
      );
    }
    return <></>;
  }

  return (
    <>
      <ListItem className={getClassNameMenuSelected()}>
        {/* Menu closed: Icon menu */}
        <RenderTooltip
          open={props.open}
          title={props.menu.name}
          child={
            <S.ButtonLink
              onClick={() => {
                props.setParentMenuSelected(props.menu.name);
                if (!hasKeyPress) {
                  if (!hasSubMenu()) {
                    dispatch(setMenuItemSelected(props.menu.route));
                  }
                  setClickMenu(true);
                  const openedMenu = !menuReducer.open;
                  dispatch(setOpenMenu(openedMenu));
                  if (openedMenu) {
                    dispatch(setModalIsOpened(false, null));
                  }
                  if (props.menu.route) {
                    navigate(props.menu.route);
                  }
                }
              }}>
              <DrawerMenuIconComponent
                route={props.menu}
                idModule={props.menu.idModule}
                itemSelected={menuReducer.menuItemSelected}
              />
            </S.ButtonLink>
          }
        />

        {/* Menu opened: Menu list */}
        {props.open && (
          <S.ContainerDataMenu>
            <S.ButtonLink
              style={{
                fontSize: 13,
                color: isMenuSelected() ? '#333' : '#6C7882',
                marginLeft: 13,
                fontWeight: 500,
                whiteSpace: 'normal'
              }}
              onClick={() => {
                openMenuList();
                if (props.menu.route) {
                  navigate(props.menu.route);
                }
              }}>
              {props.menu.name}
            </S.ButtonLink>
            {renderIconMenuOpen()}
          </S.ContainerDataMenu>
        )}
      </ListItem>

      {/* Menu opened: Menu list */}
      {(props.open && hasSubMenu() && openSectionMenu && props.preOpenMenu) ||
        clickMenu ? (
        <div className="d-flex">
          <span
            style={{
              minWidth: 1,
              marginLeft: 35,
              backgroundColor: '#DDEBFC'
            }}
          />
          <div className="flex-column" style={{ maxWidth: 160 }}>
            {props.open && renderMenuItems()}
          </div>
        </div>
      ) : null}
    </>
  );
}
